<i18n>
{
  "en": {
    "sitefooter": {
      "link1": "About This Report",
      "link2": "Schneider Sustainability Impact",
      "link3": "Data Privacy"
    }
  },
  "fr": {
    "sitefooter": {
      "link1": "A propos de ce rapport",
      "link2": "Impact de Schneider sur le développement durable",
      "link3": "La confidentialité des données"
    }
  }
}
</i18n>
<template>
  <div class="se-footer">
    <div class="l-content">
      <div class="row">
        <div class="col-xs-16 col-xs-offset-1">
          <div class="se-footer__inner">
            <div class="se-footer__links">
              <router-link :to="{ name: 'LookingAhead_About'}" v-html="$t('sitefooter.link1')"></router-link>
              <router-link :to="{ name: 'Introduction_WorkIndex' }" v-html="$t('sitefooter.link2')"></router-link>
              <a href="https://www.schneider-electric.com/en/about-us/legal/data-privacy.jsp" target="_blank" v-html="$t('sitefooter.link3')"></a>
            </div>
            <SeGreyLogo class="se-footer__logo" alt="logo"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SeGreyLogo from '../assets/se-logo-grey.svg'
export default {
  name: 'Footer',
  components: {
    SeGreyLogo
  },
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '~@/scss/vars';
  .se-footer {
    width: 100%;
    padding-top: 30px;
    padding-bottom: 40px;
    background: $lighter-grey;
    color: $grey;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid $table-border;
    @media (min-width: 768px) {
      padding-top: 20px;
      padding-bottom: 20px;
    }
    &__inner {
      display: flex;
      flex-flow: column;
      align-items: center;
      width: 100%;
      @media (min-width: 768px) {
        flex-flow: row;
        justify-content: space-between;
      }
    }
    &__links {
      display: flex;
      flex-flow: column;
      text-align: center;
      margin-bottom: 40px;
      font-size: 11px;
      @media (min-width: 768px) {
        text-align: left;
        flex-flow: row;
        margin-bottom: 0;
      }
      a {
        color: $grey;
        text-decoration: none;
        display: block;
        margin-bottom: 15px;
        @media (min-width: 768px) {
          margin-bottom: 0;
          margin-right: 60px;
        }
        // &:first-of-type {
        //
        // }
      }
    }
    &__logo {
      width: 150px;
      height: 32px;
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue